import { useEffect, useState } from "react";
import BarChartComp from "../../../component/barchart";
import DateFilter from "../../../component/dateFilter";
import LinechartComp from "../../../component/linechartComp";
import { dashboardData as initialDashboardData } from "../../../constants/businessConst";
import { useSnackbar } from "../../../component/SnackbarContext";
import axiosInstance from "../../../configuration/request";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { FaShoppingCart, FaDollarSign, FaChartLine, FaUsers } from "react-icons/fa";
import DashboardCards from "../../../component/DashboardCards";

export default function Dashboard() {
   const [analyticsData, setAnalyticsData] = useState(initialDashboardData);
  const [dateRange, setDateRange] = useState({
    startDate: dayjs().subtract(30, "day"),
    endDate: dayjs(),
  });
  const { loginDetails } = useSelector((state) => state.counter);
  const storeId = loginDetails.storeId || null;
  const showSnackbar = useSnackbar();

  useEffect(() => {
    fetchAnalytics(dateRange.startDate, dateRange.endDate);
  }, [dateRange]);

const fetchAnalytics = (startDate, endDate) => {
  axiosInstance
    .get(`/customer/store/analytics/${storeId}`, {
      params: {
        startDate: startDate.startOf('day').toISOString(),
        endDate: endDate.endOf('day').toISOString(),
      },
    })
    .then((res) => {
      if (
        res.data &&
        Array.isArray(res.data.metrics) &&
        Array.isArray(res.data.revenueTrends) &&
        Array.isArray(res.data.services)
      ) {
        const displayNameMap = {
          "wash-n-fold": "Wash & Fold",
          "drycleaning": "Dry Cleaning",
          "ironing": "Ironing",
          "tailoring": "Tailoring",
        };
        const iconMap = {
          "Total Orders": FaShoppingCart,
          "Revenue": FaDollarSign,
          "Average Order Value": FaChartLine,
          "Customer Count": FaUsers,
        };

        const updatedData = {
          ...res.data,
          services: res.data.services.map(item => ({
            ...item,
            name: displayNameMap[item.name] || item.name
          })),
          metrics: res.data.metrics.map(item => ({
            ...item,
            icon: iconMap[item.title] 
          }))
        };

        setAnalyticsData(updatedData);
      } else {
        setAnalyticsData(initialDashboardData);
      }
    })
    .catch((err) => {
      showSnackbar("Something went wrong!", "error");
      setAnalyticsData(initialDashboardData);
    });
};

  const handleRangeSelect = ({ startDate, endDate }) => {
    setDateRange({ startDate, endDate });
  };


  return (
    <div className="pt-1 pb-4 pr-6 pl-8 h-[calc(100vh-100px)] overflow-y-auto scrollbar-hide">
      <div className="flex justify-between">
        <h1 className="text-2xl font-semibold text-[var(--primary-text-color)]">Analysis and Report</h1>
        <DateFilter onSelectRange={handleRangeSelect} />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-6">
        {analyticsData.metrics.map((item, i) => (
          <DashboardCards key={i} {...item} index={i} />
        ))}
      </div>

      <div>
        <div className="py-6 px-1 shadow-sm w-full border-2 border-[#CFDBE8] rounded-xl">
          <div className="mb-4 px-5">
            <div className="text-lg font-semibold text-black">Revenue Trends</div>
            {/* <div className="text-3xl font-bold mt-1">
              {hasRevenueData ? "$56,789" : "No data"}
            </div>
            <div className="text-sm text-[#4A739C] mt-1">
              Last 30 Days{" "}
              <span className={`font-semibold ${hasRevenueData ? "text-green-600" : "text-gray-400"}`}>
                {hasRevenueData ? "+12%" : "N/A"}
              </span>
            </div> */}
          </div>
       
            <LinechartComp revenueTrends={analyticsData.revenueTrends} />
         
        </div>

        <div className="p-6 shadow-sm w-full border-2 border-[#CFDBE8] rounded-xl mt-4">
          <div className="mb-4">
            <div className="text-lg font-semibold text-black">Service Popularity</div>
            {/* <div className="text-3xl font-bold mt-1">
              {hasServiceData ? "1,234" : "No data"}
            </div>
            <div className="text-sm text-[#4A739C] mt-1">
              Last 30 Days{" "}
              <span className={`font-semibold ${hasServiceData ? "text-red-500" : "text-gray-400"}`}>
                {hasServiceData ? "-5%" : "N/A"}
              </span>
            </div> */}
          </div>

            <BarChartComp services={analyticsData.services} />
    
        </div>
      </div>
    </div>
  );
}
